export * as events from '@wix/auto_sdk_calendar_events/schemas';
export * as eventViews from '@wix/auto_sdk_calendar_event-views/schemas';
export * as participations from '@wix/auto_sdk_calendar_participations/schemas';
export * as schedules from '@wix/auto_sdk_calendar_schedules/schemas';
export * as scheduleTimeFrames from '@wix/auto_sdk_calendar_schedule-time-frames/schemas';
